var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetallicGrayUploadTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6112_100714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#718EBF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6112_100714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 18.4258C12.4745 18.4258 12.5698 18.4653 12.6402 18.5356C12.7105 18.6059 12.75 18.7013 12.75 18.8008V20.6758C12.75 20.8747 12.829 21.0655 12.9697 21.2061C13.1103 21.3468 13.3011 21.4258 13.5 21.4258H22.5C22.6989 21.4258 22.8897 21.3468 23.0303 21.2061C23.171 21.0655 23.25 20.8747 23.25 20.6758V18.8008C23.25 18.7013 23.2895 18.6059 23.3598 18.5356C23.4302 18.4653 23.5255 18.4258 23.625 18.4258C23.7245 18.4258 23.8198 18.4653 23.8902 18.5356C23.9605 18.6059 24 18.7013 24 18.8008V20.6758C24 21.0736 23.842 21.4551 23.5607 21.7364C23.2794 22.0177 22.8978 22.1758 22.5 22.1758H13.5C13.1022 22.1758 12.7206 22.0177 12.4393 21.7364C12.158 21.4551 12 21.0736 12 20.6758V18.8008C12 18.7013 12.0395 18.6059 12.1098 18.5356C12.1802 18.4653 12.2755 18.4258 12.375 18.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.266 11.8595C18.2312 11.8246 18.1898 11.7969 18.1442 11.778C18.0987 11.7591 18.0498 11.7493 18.0005 11.7493C17.9512 11.7493 17.9023 11.7591 17.8568 11.778C17.8112 11.7969 17.7698 11.8246 17.735 11.8595L15.485 14.1095C15.4146 14.1799 15.375 14.2754 15.375 14.375C15.375 14.4746 15.4146 14.5701 15.485 14.6405C15.5554 14.7109 15.6509 14.7505 15.7505 14.7505C15.8501 14.7505 15.9456 14.7109 16.016 14.6405L17.6255 13.0302L17.6255 19.625C17.6255 19.7245 17.665 19.8198 17.7353 19.8902C17.8057 19.9605 17.901 20 18.0005 20C18.1 20 18.1953 19.9605 18.2657 19.8902C18.336 19.8198 18.3755 19.7245 18.3755 19.625L18.3755 13.0302L19.985 14.6405C20.0554 14.7109 20.1509 14.7505 20.2505 14.7505C20.3501 14.7505 20.4456 14.7109 20.516 14.6405C20.5864 14.5701 20.626 14.4746 20.626 14.375C20.626 14.2754 20.5864 14.1799 20.516 14.1095L18.266 11.8595Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6112_100714",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6112_100714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6112_100714",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6112_100714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetallicGrayUploadTableIcon);
export default __webpack_public_path__ + "static/media/metallic-gray-upload-table-icon.d51f773415f826476ed261adc45301a8.svg";
export { ForwardRef as ReactComponent };